<template>
  <div class="processMonitoring">
    <div class="reportBasic-subTitle">
      {{ $tc('lang.factoryReport.Human_Resourse_Records') }}
    </div>
    <div class="productProcess-list">
      <div class="dian1 dian2">
        <span>{{ $tc('lang.factoryReport.Management') }}：</span>
      </div>
      <div class="dian1">
        <span>{{ $tc('lang.factoryReport.Staff_Registered') }}</span>
        <a-input v-model="data.hrStaffregistered"></a-input>
      </div>
      <div class="dian1">
        <span>{{ $tc('lang.factoryReport.Staff_on_Duty') }}</span>
        <a-input v-model="data.hrStaffonduty"></a-input>
      </div>
      <div class="dian1">
        <span>{{ $tc('lang.factoryReport.remarks') }}</span>
        <a-input v-model="data.hrRemark"></a-input>
      </div>
    </div>
    <div class="productProcess-list">
      <div class="dian1 dian2">
        <span>{{ $tc('lang.factoryReport.Product_Department') }}：</span>
      </div>
      <div class="dian1">
        <span>{{ $tc('lang.factoryReport.Staff_Registered') }}</span>
        <a-input v-model="data.hrStaffregisteredone"></a-input>
      </div>
      <div class="dian1">
        <span>{{ $tc('lang.factoryReport.Staff_on_Duty') }}</span>
        <a-input v-model="data.hrStaffondutyone"></a-input>
      </div>
      <div class="dian1">
        <span>{{ $tc('lang.factoryReport.remarks') }}</span>
        <a-input v-model="data.hrRemarkone"></a-input>
      </div>
    </div>
    <div class="productProcess-list">
      <div class="dian1 dian2">
        <span>{{ $tc('lang.factoryReport.Logitics_Division') }}：</span>
      </div>
      <div class="dian1">
        <span>{{ $tc('lang.factoryReport.Staff_Registered') }}</span>
        <a-input v-model="data.hrStaffregisteredtwo"></a-input>
      </div>
      <div class="dian1">
        <span>{{ $tc('lang.factoryReport.Staff_on_Duty') }}</span>
        <a-input v-model="data.hrStaffondutytwo"></a-input>
      </div>
      <div class="dian1">
        <span>{{ $tc('lang.factoryReport.remarks') }}</span>
        <a-input v-model="data.hrRemarktwo"></a-input>
      </div>
    </div>
    <div class="productProcess-list">
      <div class="dian1 dian2">
        <span>{{ $tc('lang.factoryReport.Busiess_Department') }}：</span>
      </div>
      <div class="dian1">
        <span>{{ $tc('lang.factoryReport.Staff_Registered') }}</span>
        <a-input v-model="data.hrStaffregisteredthree"></a-input>
      </div>
      <div class="dian1">
        <span>{{ $tc('lang.factoryReport.Staff_on_Duty') }}</span>
        <a-input v-model="data.hrStaffondutythree"></a-input>
      </div>
      <div class="dian1">
        <span>{{ $tc('lang.factoryReport.remarks') }}</span>
        <a-input v-model="data.hrRemarkthree"></a-input>
      </div>
    </div>
    <div class="productProcess-list">
      <div class="dian1 dian2">
        <span
          >{{
            $tc('lang.factoryReport.Research_and_Development_Department')
          }}：</span
        >
      </div>
      <div class="dian1">
        <span>{{ $tc('lang.factoryReport.Staff_Registered') }}</span>
        <a-input v-model="data.hrStaffregisteredfour"></a-input>
      </div>
      <div class="dian1">
        <span>{{ $tc('lang.factoryReport.Staff_on_Duty') }}</span>
        <a-input v-model="data.hrStaffondutyfour"></a-input>
      </div>
      <div class="dian1">
        <span>{{ $tc('lang.factoryReport.remarks') }}</span>
        <a-input v-model="data.hrRemarkfour"></a-input>
      </div>
    </div>
    <div class="productProcess-list">
      <div class="dian1 dian2">
        <span>{{ $tc('lang.factoryReport.Admiistrative_Department') }}：</span>
      </div>
      <div class="dian1">
        <span>{{ $tc('lang.factoryReport.Staff_Registered') }}</span>
        <a-input v-model="data.hrStaffregisteredfive"></a-input>
      </div>
      <div class="dian1">
        <span>{{ $tc('lang.factoryReport.Staff_on_Duty') }}</span>
        <a-input v-model="data.hrStaffondutyfive"></a-input>
      </div>
      <div class="dian1">
        <span>{{ $tc('lang.factoryReport.remarks') }}</span>
        <a-input v-model="data.hrRemarkfive"></a-input>
      </div>
    </div>
    <div class="productProcess-list">
      <div class="dian1 dian2">
        <span>{{ $tc('lang.factoryReport.Others') }}：</span>
      </div>
      <div class="dian1">
        <span>{{ $tc('lang.factoryReport.Staff_Registered') }}</span>
        <a-input v-model="data.hrStaffregisteredsix"></a-input>
      </div>
      <div class="dian1">
        <span>{{ $tc('lang.factoryReport.Staff_on_Duty') }}</span>
        <a-input v-model="data.hrStaffondutysix"></a-input>
      </div>
      <div class="dian1">
        <span>{{ $tc('lang.factoryReport.remarks') }}</span>
        <a-input v-model="data.hrRemarksix"></a-input>
      </div>
    </div>
    <div class="productProcess-list">
      <div class="dian1 dian2">
        <span>{{ $tc('lang.factoryReport.All') }}：</span>
      </div>
      <div class="dian1">
        <span>{{ $tc('lang.factoryReport.Staff_Registered') }}</span>
        <a-input v-model="data.hrStaffregisteredseven"></a-input>
      </div>
      <div class="dian1">
        <span>{{ $tc('lang.factoryReport.Staff_on_Duty') }}</span>
        <a-input v-model="data.hrStaffondutyseven"></a-input>
      </div>
      <div class="dian1">
        <span>{{ $tc('lang.factoryReport.remarks') }}</span>
        <a-input v-model="data.hrRemarkseven"></a-input>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.factoryReport.Staff_List') }}</span>
      <div class="img">
        <show-img
          :data="processMonitoring.freportStafflist"
          :otherData="{
            mediaName: '员工花名册',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'freportStafflist',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.factoryReport.Staff_Archives') }}</span>
      <div class="img">
        <show-img
          :data="processMonitoring.freportStaffarchives"
          :otherData="{
            mediaName: '员工档案记录',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'freportStaffarchives',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.factoryReport.Recent_Months_Attendance') }}</span>
      <div class="img">
        <show-img
          :data="processMonitoring.freportAttendance"
          :otherData="{
            mediaName: '近3个月考勤记录',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'freportAttendance',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.factoryReport.Recent_Months_Salary') }}</span>
      <div class="img">
        <show-img
          :data="processMonitoring.freportSalary"
          :otherData="{
            mediaName: '近3个月工资记录',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'freportSalary',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
  </div>
</template>
<script>
import showImg from './showImg';

export default {
  data() {
    return {
      data: [],
      id: this.$route.query.id,
      modalData: {},
    };
  },
  computed: {
    factoryDetails: {
      get() {
        return JSON.parse(
          JSON.stringify(this.$store.state.report.factoryDetails),
        );
      },
    },
    processMonitoring: {
      get() {
        return JSON.parse(
          JSON.stringify(
            this.$store.state.report.factoryImgList.processMonitoring,
          ),
        );
      },
    },
  },
  components: {
    showImg,
  },
  created() {
    this.getSelectDate();
  },
  methods: {
    getSelectDate() {
      this.$http
        .post('/hzwmj/factory-hr/seachFactoryHr', {
          freportId: this.factoryDetails.freportId,
        })
        .then(data => {
          if (data.data) {
            this.data = data.data;
          } else {
            this.data = [];
          }
        })
        .catch(() => {
          this.data = [];
        });
    },
    saveImg() {
      let fileList = [];
      let fileList1 = [];
      let fileList2 = [];
      let fileList3 = [];
      this.processMonitoring.freportStafflist.forEach(item => {
        fileList.push(item.id);
      });
      this.processMonitoring.freportStaffarchives.forEach(item => {
        fileList1.push(item.id);
      });
      this.processMonitoring.freportAttendance.forEach(item => {
        fileList2.push(item.id);
      });
      this.processMonitoring.freportSalary.forEach(item => {
        fileList3.push(item.id);
      });
      var postData = {
        freportId: this.factoryDetails.freportId,
        freportMedianame: '人力资源',
        freportMediatype: '1',
        modelType: '6',

        freportStafflist: fileList.join(','),
        freportStaffarchives: fileList1.join(','),
        freportAttendance: fileList2.join(','),
        freportSalary: fileList3.join(','),
      };
      // postData[type] = fileList.join(',');
      this.$http
        .post('/hzwmj/factory-media/saveOrUpdateFactoryMedia', postData)
        .then(data => {
          if (data) {
            // this.visible = false;
            this.$message.success('保存成功');
            this.$store.dispatch(
              'report/getfactoryImg',
              this.factoryDetails.freportId,
            );
          } else {
            this.$message.error('保存失败');
          }
        })
        .catch(() => {
          this.$message.error('保存失败');
        });
    },
    handleSubmit() {
      this.$http
        .post('/hzwmj/factory-hr/saveorUpdateFactoryHr', {
          ...this.data,
        })
        .then(data => {
          if (data) {
            this.$message.success('保存成功');
            this.getSelectDate();
          } else {
            this.$message.error('保存失败');
          }
        })
        .catch(() => {
          this.$message.error('保存失败');
        });
    },
  },
};
</script>
<style lang="less">
.processMonitoring {
  .desOfGoods-con {
    display: flex;
    margin-top: 30px;
    .button-group {
      width: 130px;
      flex-shrink: 0;
    }
    .img {
      flex-grow: 1;
    }
    > span {
      display: inline-block;
      width: 100px;
      flex-shrink: 0;
      padding-left: 20px;
      // text-align: center;
    }
    // img {
    //   width: 20%;
    //   height: 150px;
    //   margin: 0 20px 20px;
    // }
  }
  .dian1 {
    margin-bottom: 10px;
    > span:nth-child(1) {
      width: 120px;
      padding-left: 20px;
      display: inline-block;
    }
    input {
      width: 150px;
    }
    .ant-radio-group {
      width: 220px;
    }
  }
  .dian2 {
    font-size: 20px;
    color: #1890ff;
  }
}
</style>
